import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../context/AuthContext';
import axios from "axios";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2'
import { API_BASE_URL } from "../../../../../Helpers/apiConfig";

const formatDate = (isoString) => {
    if (!isoString) return "-";
    const date = new Date(isoString);
    if (isNaN(date.getTime())) return isoString;
    return date.toLocaleString("tr-TR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit"
    });
};

export const AdminEditUser = () => {
    const { t } = useTranslation()
    const [data, setData] = useState([]);
    const [detail, setDetail] = useState([]);

    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [passwordMsg, setPasswordMsg] = useState([]);
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [roles, setRoles] = useState([]);

    const getAuthHeaders = () => ({
        "accept": "*/*",
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': 'false',
        'Authorization': 'Bearer ' + user.token
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const currentRole = roles.find(r => r.roleName === data.roleName);
            let url = `${API_BASE_URL}/admin/User/UpdateUser`;
            await axios({
                method: 'PUT',
                url: url,
                data: {
                    id: data.id,
                    username: document.getElementById("username").value,
                    fullName: document.getElementById("fullName").value,
                    roleId: currentRole ? currentRole.id : data.roleId,
                    createdAt: data.createdAt,
                    lastLogin: data.lastLogin,
                    expiryDate: document.getElementById("expiryDate").value,
                    isTrial: document.getElementById("isTrial").value === "true",
                    isVerified: data.isVerified,
                    isInvidual: data.isInvidual,
                    isStudent: data.isStudent,
                    isManager: data.isManager,
                    schoolId: detail.schoolId,
                    classId: detail.classId,
                    sectionId: detail.sectionId,
                    userNote: ".",
                    status: "."
                },
                headers: getAuthHeaders()
            }).then(res => {
                if (res.status === 200) {

                    if (res.data['success']) {
                        Swal.fire({
                            title: "Başırılı!",
                            icon: "success",
                            confirmButtonText: `Tamam`,
                            timer: 3000,
                        }).then(() => {
                            window.location.reload();
                        })
                    }
                    else {
                        setMsg(res.data['message']);
                        Swal.fire({
                            title: res.data['message'],
                            icon: "error",
                            timer: 3000,
                            confirmButtonText: `Tamam`
                        }).then(() => {
                            window.location.reload();
                        });
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            alert(err.message);
            setMsg(err?.message || "Bir hata oluştu");
        }
    }

    const onPasswordSubmit = async (e) => {
        e.preventDefault();
        const newPassword = document.getElementById("newPassword").value;
        const newPasswordVerify = document.getElementById("newPasswordVerify").value;

        if (!newPassword || newPassword !== newPasswordVerify) {
            setPasswordMsg("Şifreler eşleşmiyor.");
            return;
        }

        try {
            await axios({
                method: 'PUT',
                url: `${API_BASE_URL}/admin/User/AdminUpdateUserPassword`,
                params: {
                    userId: data.id,
                    newPassword: newPassword
                },
                headers: getAuthHeaders()
            }).then(res => {
                if (res.status === 200 && res.data['success']) {
                    Swal.fire({
                        title: "Şifre Güncellendi!",
                        icon: "success",
                        confirmButtonText: `Tamam`,
                        timer: 3000,
                    });
                    document.getElementById("newPassword").value = "";
                    document.getElementById("newPasswordVerify").value = "";
                    setPasswordMsg("");
                }
                else {
                    setPasswordMsg(res.data['message'] || "Beklenmedik Bir Hata Oluştu.");
                }
            });
        } catch (err) {
            setPasswordMsg(err.message);
        }
    }

    const getUser = async (e) => {

        setLoading(true);
        try {
            let url = `${API_BASE_URL}/admin/User/GetUserById`;
            await axios({
                method: 'GET',
                url: url,
                params: {
                    userId: params['id']
                },
                headers: getAuthHeaders()
            }).then(res => {
                if (res.status === 200) {
                    if (res.data['success']) {
                        console.log(res.data['data']);
                        setData(res.data['data']['user'])
                        setDetail(res.data['data']['detail'])

                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        } catch (err) {
            setMsg(err?.message || "Bir hata oluştu");
        }
        setLoading(false);
    }
    const fetchData = async () => {
        setLoading(true);
        try {
            let url = `${API_BASE_URL}/admin/Role/GetList`;
            await axios({
                method: 'GET',
                url: url,
                headers: getAuthHeaders()
            }).then(res => {

                if (res.status === 200) {
                    if (res.data['success']) {
                        setRoles(res.data['data']);
                    }
                    else {
                        setMsg(res.data['message']);
                    }
                }
                else {
                    setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                }
            });
        }
        catch (err) {
            setMsg(err?.message || "Bir hata oluştu");
        }
        setLoading(false);
    }
    useEffect(() => {
        getUser();
        fetchData();
    }, [])

    const badge = (label, active, activeClass = "bg-success", inactiveClass = "bg-secondary") => (
        <span className={`badge ${active ? activeClass : inactiveClass} me-2 mb-2`} style={{ fontSize: "0.85em", padding: "0.5em 0.9em" }}>
            {label}
        </span>
    );

    return (
        <div className="container-fluid py-3 py-md-4">
            <div className="row justify-content-center">
                <div className="col-12 col-lg-8 col-xl-7">
                    <div className="card shadow-sm border-0">
                        <div className="card-body p-3 p-md-4">
                            <div className="text-center mb-4">
                                <h1 className="h3 mb-0">{t("editUser")}</h1>
                            </div>

                            {msg ? <div className="alert alert-danger">{msg}</div> : null}
                            {loading && <div className="text-center my-4">Veriler Yükleniyor...</div>}

                            {!loading && (
                                <>
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-12 col-md-6 mb-3">
                                                <label for="username" className="form-label">{t("email")}</label>
                                                <textarea className="form-control" id="username" rows={1} defaultValue={data.username} />
                                            </div>
                                            <div className="col-12 col-md-6 mb-3">
                                                <label for="fullName" className="form-label">{t('namesurname')}</label>
                                                <textarea className="form-control" id="fullName" rows={1} defaultValue={data.fullName} />
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 col-md-6 mb-3">
                                                <label className="form-label d-block text-muted small mb-1">{t('createdAt')}</label>
                                                <div>{formatDate(data.createdAt)}</div>
                                            </div>
                                            <div className="col-12 col-md-6 mb-3">
                                                <label className="form-label d-block text-muted small mb-1">{t('lastLogin')}</label>
                                                <div>{formatDate(data.lastLogin)}</div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 col-md-6 mb-3">
                                                <label className="form-label" for="expiryDate">{t("expiryDate")}</label>
                                                <input type="datetime-local" className="form-control" id="expiryDate" name="expiryDate" defaultValue={data.expiryDate} />
                                            </div>
                                            <div className="col-12 col-md-6 mb-3">
                                                <label for="isTrial" className="form-label">{t('isActive')}</label>
                                                {data.isTrial ? (
                                                    <select id="isTrial" className="form-select" required >
                                                        <option key="0" value="true" selected>{t('passive')}</option>
                                                        <option key="1" value="false" >{t('active')}</option>
                                                    </select>
                                                ) : (
                                                    <select id="isTrial" className="form-select" required >
                                                        <option key="1" value="false" selected>{t('active')}</option>
                                                        <option key="0" value="true" >{t('passive')}</option>
                                                    </select>
                                                )}
                                            </div>
                                        </div>

                                        <div className="mb-4">
                                            <label className="form-label d-block">Kullanıcı Türü</label>
                                            {badge(data.isVerified ? "Doğrulanmış" : "Doğrulanmamış", data.isVerified, "bg-success", "bg-danger")}
                                            {badge(data.isInvidual ? "Bireysel" : "Kurumsal", true, data.isInvidual ? "bg-info text-dark" : "bg-primary")}
                                            {data.isStudent && badge("Öğrenci", true, "bg-secondary")}
                                            {data.isManager && badge("Yönetici", true, "bg-dark")}
                                        </div>

                                        <div className="d-flex justify-content-center">
                                            <button type="submit" className="btn btn-primary btn-lg px-4">{t('update')}</button>
                                        </div>
                                    </form>

                                    <hr className="my-4" />

                                    <h5 className="text-center mb-3">Şifre Güncelle</h5>
                                    <form onSubmit={onPasswordSubmit}>
                                        {passwordMsg ? <div className="alert alert-danger">{passwordMsg}</div> : null}
                                        <div className="row">
                                            <div className="col-12 col-md-6 mb-3">
                                                <label for="newPassword" className="form-label">Yeni Şifre</label>
                                                <input type="password" className="form-control" id="newPassword" />
                                            </div>
                                            <div className="col-12 col-md-6 mb-3">
                                                <label for="newPasswordVerify" className="form-label">Yeni Şifre (Tekrar)</label>
                                                <input type="password" className="form-control" id="newPasswordVerify" />
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-center">
                                            <button type="submit" className="btn btn-outline-primary px-4">Şifreyi Güncelle</button>
                                        </div>
                                    </form>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default AdminEditUser;
